import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ConfigService } from '@finder/core/config.service';
import { MultiSelectDirective } from '@finder/features/list/components/multi-select/multi-select.class';
import { MultiSelectService } from '@finder/shared/services/multi-select/multi-select.service';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-mobile-multi-select',
    templateUrl: './mobile-multi-select.component.html',
    styleUrls: ['./mobile-multi-select.component.scss'],
    standalone: true,
    imports: [
        RaCheckboxComponent,
        CommonModule,
        ButtonComponent,
    ]
})
export class MobileMultiSelectComponent extends MultiSelectDirective implements ModalChildComponent, OnInit, OnDestroy {
    @Input() disableOptions: boolean;

    data: any;
    parentComponent: ModalComponent;

    get labels() {
        return this._labels;
    }

    constructor(
        protected multiSelectService: MultiSelectService,
        protected configService: ConfigService,
    ) {
        super(multiSelectService, configService);
    }

    ngOnInit() {
        this._labels = this.data.labels;
        super.ngOnInit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    /**
     * Close modal
     */
    dismiss() {
        this.parentComponent.dismiss();
    }
}
